import {
  FAILURE,
  SUCCESS,
  REQUEST,
  FULFILL,
} from "common/rdx/reducer-status.constants";

import {
  GET_USER_LIST,
  POST_NEW_USER,
  ADD_USER_ROLES,
  DELETE_USER,
  EDIT_USER,
} from "features/coordinator-user/state/coordinator-user.actions";

const INITIAL_STATE = {
  status: "",
  message: null,
  userList: [],
  userDetail: null,
};

// eslint-disable-next-line default-param-last
const getUserListReducer = (state = INITIAL_STATE, action) => {
  const { status, message, payload } = action;

  if (status === REQUEST) {
    return {
      ...state,
      status,
    };
  }
  if (status === SUCCESS) {
    return {
      ...state,
      status,
      userList: payload.userList,
      message,
    };
  }
  if (status === FAILURE) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FULFILL) {
    return {
      ...state,
      status,
    };
  }

  return state;
};

// eslint-disable-next-line default-param-last
const postNewUserReducer = (state = INITIAL_STATE, action) => {
  const { status, message, payload } = action;

  if (status === REQUEST) {
    return {
      ...state,
      status,
    };
  }
  if (status === SUCCESS) {
    return {
      ...state,
      status,
      message,
      userDetail: payload.userData,
    };
  }
  if (status === FAILURE) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FULFILL) {
    return {
      ...state,
      status,
    };
  }

  return state;
};

// eslint-disable-next-line default-param-last
const addUserRolesReducer = (state = INITIAL_STATE, action) => {
  const { status, message } = action;

  if (status === REQUEST) {
    return {
      ...state,
      status,
    };
  }
  if (status === SUCCESS) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FAILURE) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FULFILL) {
    return {
      ...state,
      status,
    };
  }

  return state;
};

// eslint-disable-next-line default-param-last
const deleteUserReducer = (state = INITIAL_STATE, action) => {
  const { status, message } = action;

  if (status === REQUEST) {
    return {
      ...state,
      status,
    };
  }
  if (status === SUCCESS) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FAILURE) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FULFILL) {
    return {
      ...state,
      status,
    };
  }

  return state;
};

// eslint-disable-next-line default-param-last
const editUserReducer = (state = INITIAL_STATE, action) => {
  const { status, message } = action;

  if (status === REQUEST) {
    return {
      ...state,
      status,
    };
  }
  if (status === SUCCESS) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FAILURE) {
    return {
      ...state,
      status,
      message,
    };
  }
  if (status === FULFILL) {
    return {
      ...state,
      status,
    };
  }

  return state;
};

// eslint-disable-next-line default-param-last
const coordinatorUserReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  if (type === GET_USER_LIST) {
    return getUserListReducer(state, action);
  }
  if (type === POST_NEW_USER) {
    return postNewUserReducer(state, action);
  }
  if (type === ADD_USER_ROLES) {
    return addUserRolesReducer(state, action);
  }
  if (type === DELETE_USER) {
    return deleteUserReducer(state, action);
  }
  if (type === EDIT_USER) {
    return editUserReducer(state, action);
  }

  return state;
};

export default coordinatorUserReducer;
